import React, { useState, useEffect } from "react";
import "../css/Footer.css"; // Dedicated styles

import { NavLink } from "react-router-dom";
// Import highly descriptive modern icons from FontAwesome
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInfoCircle,
  FaAddressBook,
  FaAward,
  FaGavel,
  FaFileContract,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaSchool,
  FaComments,
  FaGift,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaGraduationCap,
  FaRocket,
  FaMobileAlt,
  FaQuestionCircle,
  FaUserGraduate,
  FaFileAlt,
  FaClipboardCheck,
  FaUserCog
} from "react-icons/fa";

// Import your brand assets here
import footerBg from "../../images/Banner8.png";
import brandLogo from "../../images/logo.png";

function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Monitor scroll position to toggle back-to-top button visibility
  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollTop && window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else if (showScrollTop && window.pageYOffset <= 300) {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScrollTop]);

  return (
    <footer
      className="main-footer"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="footer-main-container">
        <div className="footer-columns-row">

          {/* Column 1: Brand details & contacts */}
          <div className="footer-col-brand footer-col-item">
            <div className="footer-brand-column">
              <img src={brandLogo} alt="Brand Logo" className="footer-logo mb-3" />
              <p className="footer-description">
                Crestest delivers innovative EdTech solutions that empower students,
                educators, schools, and institutions through intelligent learning,
                assessment, and academic management platforms.
              </p>

              <p className="footer-description">
                From AI-powered learning and national academic challenges to Associative
                Academic ERP and custom EdTech software, we build scalable digital
                solutions designed for smarter, connected education.
              </p>
              <div className="footer-contacts">
                <p className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <strong>P:</strong>
                  <a href="tel:+917595856611" className="contact-phone-link">
                    + (91) 75958 56611
                  </a>
                </p>

                <p className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <strong>P:</strong>
                  <a href="tel:+916289581169" className="contact-phone-link">
                    + (91) 62895 81169
                  </a>
                </p>
                <p className="contact-item email-highlight">
                  <FaEnvelope className="contact-icon" /> <strong>E:</strong> <a href="mailto:info@crestest.com">info@crestest.com</a>
                </p>
              </div>
            </div>
          </div>

          {/* Column 2: Navigation Links (Company) */}
          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li>
                  <NavLink to="/about">
                    <FaInfoCircle className="link-icon" /> About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/unique-features">
                    <FaAward className="link-icon" /> Unique Features
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact">
                    <FaAddressBook className="link-icon" /> Contact Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/associates">
                    <FaGift className="link-icon" /> Associates
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 3: Verticles */}
          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Product Domains</h4>
              <ul className="footer-list">
                <li>
                  <NavLink to="/lms">
                    <FaGraduationCap className="link-icon" /> Premium Learning Hub
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/forum">
                    <FaComments className="link-icon" /> Scholars’ Forum
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/kirnavali">
                    <FaRocket className="link-icon" /> National Challenge
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/associates">
                    <FaSchool className="link-icon" /> Crestest School ERP
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/software">
                    <FaLaptopCode className="link-icon" /> EdTech Solutions
                  </NavLink>
                </li>
                <li>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.schemaphic.crestest&pcampaignid=web_share"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaMobileAlt className="link-icon" /> Mobile Application
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 4: Services */}
          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Services</h4>

              <ul className="footer-list">
                <li>
                  <NavLink to="/online-exam">
                    <FaLaptopCode className="link-icon" /> Online Exam
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/e-library">
                    <FaBookReader className="link-icon" /> e-Library
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/performance-scorecard">
                    <FaChartLine className="link-icon" /> Performance Scorecard
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/group-discussion">
                    <FaComments className="link-icon" /> Group Discussion
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/quiz">
                    <FaQuestionCircle className="link-icon" /> Quiz
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/associates">
                    <FaUserGraduate className="link-icon" /> Admission Management
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/associates">
                    <FaFileAlt className="link-icon" /> Content Management
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/associates">
                    <FaClipboardCheck className="link-icon" /> Exam Management
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/associates">
                    <FaUserCog className="link-icon" /> Admin Management
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 5: Quick Links */}
          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-list">
                <li>
                  <NavLink to="/faq">
                    <FaGift className="link-icon" /> FAQs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/privacy-policy">
                    <FaFileContract className="link-icon" /> Privacy Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/terms-and-conditions">
                    <FaGavel className="link-icon" /> Terms & Conditions
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 6: Connect */}
          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-list">
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100070855191458&mibextid=ZbWKwL"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="link-icon" /> Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/crestestlearning?igsh=MTMyaGNyNGhxbzMyOA=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram className="link-icon" /> Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/CrestestL?t=HZ0eOHnnFhuaUxE6Ottp0w&s=08"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter className="link-icon" /> X (Twitter)
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com/@crestestlearning7882?si=C3Nc705m7PwsRWaz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube className="link-icon" /> YouTube
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/posts/crestest-learning_activity-7120658377931710464-fR85?utm_source=share&utm_medium=member_android"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="link-icon" /> LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </div>

        {/* Dynamic Horizontal Line Splitter */}
        <hr className="footer-divider" />

        {/* Copyright strip */}
        <div className="footer-bottom-strip">
          <p className="footer-copyright mb-0 text-center">
            &copy; {new Date().getFullYear()} Crestest. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;